import { LoaderCircle } from 'lucide-react';
import styles from './LoadingSpinner.module.scss';

type LoadingSpinnerProps = {
    size?: number;
    borderWidth?: number;
    color?: string;
    className?: string;
    text?: string;
};

const LoadingSpinner = ({ size = 26, color = '#9b51e0', className = '', text = 'Loading...' }: LoadingSpinnerProps) => {
    return (
        <div className={`${styles.loadingSpinnerContainer} ${className || ''}`}>
            <LoaderCircle size={size} className={styles.spinner} color={color} /> {text}
        </div>
    );
};

export default LoadingSpinner;
